export const buildCopyMeasureCaption = (caption: string, existingCaptions: string[]): string => {
  const existing = new Set(existingCaptions.map((c) => c.toLowerCase()));
  const base = `Copy of ${caption}`;
  if (!existing.has(base.toLowerCase())) {
    return base;
  }

  let counter = 2;
  while (existing.has(`${base} (${counter})`.toLowerCase())) {
    counter++;
  }
  return `${base} (${counter})`;
};
